import { useSelector } from "react-redux";

import { Activity, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { PERMISSON_DATAHOLDER } from "../../modules/processOverview/store/constants";
import { TASK_DETAIL_ACTIVITY_ID } from "../../modules/processOverview/store/actions";

import hasDescriptor = Activity.DataHolder.hasDescriptor;

export function useHasTaskPermission() {
	return (
		useSelector(
			ActivitySelectors.activityPropById(TASK_DETAIL_ACTIVITY_ID, activity => {
				const data = activity.dataHolders.find(
					hasDescriptor({ [PERMISSON_DATAHOLDER]: PERMISSON_DATAHOLDER })
				)?.data;
				return data && "isUserPermittedForTask" in data ? !!data.isUserPermittedForTask : undefined;
			})
		) ?? undefined
	);
}
